import { render, staticRenderFns } from "./EditarRecargoModalType.vue?vue&type=template&id=73a7e676"
import script from "./EditarRecargoModalType.vue?vue&type=script&lang=js"
export * from "./EditarRecargoModalType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports